module.exports = __webpack_public_path__ + "static/js/3.7ec94c70.chunk.worker.js"